import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';

import evolution from './EvolutionEvent';
import master from './MasterEvent';
import yes from './YesEvent';
import pull from './PullEvent';
import bodysway from './BodyswayEvent';
import routine from './RoutineEvent';
import other from './OtherEvent';

import quoteImg from '../../static/img/events_page/quote.png';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'white',
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  hero: {
    height: 'auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  header: {
    position: 'relative',
    top: '10px',
    width: '100%',
    padding: 0,
    textAlign: 'left',
    textTransform: 'uppercase',
    [theme.breakpoints.down(800)]: {
      top: '7px',
      fontSize: '2.5em',
    },
  },
  heroImg: {
    height: 'auto',
    width: '100%',
  },
  section: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  sectionImg: {
    width: '100%',
    height: 'auto',
  },
  sectionText: {
    paddingBottom: theme.spacing(2),
  },
  sectionHeader: {
    marginBottom: theme.spacing(2),
    fontSize: '2em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  sectionSubHeader: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    fontSize: '1em',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  tabsButton: {
    letterSpacing: '1px',
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
  },
  middleColumn: {
    textAlign: 'center',
    padding: theme.spacing(),
    height: '100%',
  },
  row: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(2),
  },
  policyButton: {
    marginTop: theme.spacing(),
  },
  cost: {
    display: 'inline-block',
    textTransform: 'uppercase',
    paddingRight: theme.spacing(4),
  },
  costPrice: {
    display: 'inline-block',
    fontSize: '1.5em',
    letterSpacing: '1px',
  },
  quoteImg: {
    padding: theme.spacing(2),
  },
  quote: {
    letterSpacing: '1px',
    fontSize: '1.2em',
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  quoteAuthor: {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
});


const events = [
  evolution,
  master,
  yes,
  pull,
  bodysway,
  routine,
  other,
];

class DebbieRosasEventsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: '0',
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, tab) {
    this.setState({
      currentTab: tab,
    });
  }

  render() {
    const { classes } = this.props;
    const { currentTab } = this.state;

    return (
      <div className={classes.page}>
        <NavBar />
        <main className={classes.container}>
          <div className={classes.appBarSpacer} />
          <div className={classes.content}>
            <div className={classes.section}>
              <Grid container>
                <Grid item xs={7}>
                  <Typography color="textSecondary" variant="h2" className={classes.sectionHeader}>Debbie Rosas Events</Typography>
                  <hr className={classes.divider} />
                </Grid>
                <Grid item xs={12}>
                  <Button variant={currentTab === '0' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => this.handleClick(e, '0')}>Evolution</Button>
                  <Button variant={currentTab === '1' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => this.handleClick(e, '1')}>Master Class</Button>
                  <Button variant={currentTab === '2' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => this.handleClick(e, '2')}>Dance Yes</Button>
                  <Button variant={currentTab === '3' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => this.handleClick(e, '3')}>Dance Pull</Button>
                  <Button variant={currentTab === '4' ? 'contained' : 'text'} color="secondary" disabled className={classes.tabsButton} onClick={e => this.handleClick(e, '4')}>{'The Body\'s Way'}</Button>
                  <Button variant={currentTab === '5' ? 'contained' : 'text'} color="secondary" disabled className={classes.tabsButton} onClick={e => this.handleClick(e, '5')}>Routine</Button>
                  <Button variant={currentTab === '6' ? 'contained' : 'text'} color="secondary" disabled className={classes.tabsButton} onClick={e => this.handleClick(e, '6')}>Other</Button>
                </Grid>
              </Grid>
            </div>
            <div className={classes.hero}>
              <img className={classes.heroImg} alt="Debbie Rosas Events" src={events[currentTab].hero} />
            </div>
            <div className={classes.section}>
              <Grid container>
                <Grid item xs={12} sm={5}>
                  <Typography variant="h2" color="textSecondary" className={classes.sectionHeader}>{events[currentTab].title}</Typography>
                  {events[currentTab].description}
                </Grid>
                <hr />
                <Grid item xs={12} sm={5}>
                  <img src={quoteImg} alt="quote" className={classes.quoteImg} />
                  <Typography variant="h5" className={classes.quote}>{events[currentTab].quote}</Typography>
                  <Typography className={classes.quoteAuthor}>{'-' + events[currentTab].quoteAuthor}</Typography>
                </Grid>
              </Grid>
            </div>
            <div className={classes.section}>
              <Grid container justifyContent="space-between">
                <Grid item xs={12} sm={3}>
                  <img src={events[currentTab].img1} alt="one" className={classes.sectionImg} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Grid container alignContent="space-between" justifyContent="space-between" direction="column" className={classes.middleColumn}>
                    <Grid item className={classes.row}>
                      <Typography variant="h6" className={classes.sectionSubHeader}>{events[currentTab].eligibility}</Typography>
                      <Button variant="outlined" href="/finder/training?trainer=Debbie%20Rosas" className={classes.button}>{events[currentTab].button}</Button>
                    </Grid>
                    <Grid item className={classes.row}>
                      <span>
                        <Typography className={classes.cost}>Cost:</Typography>
                        <Typography className={classes.costPrice}>{events[currentTab].price}</Typography>
                      </span>
{/*                      <Button className={classes.policyButton} fullWidth variant="contained" color="secondary">Payment Policy</Button>
                      <Button className={classes.policyButton} fullWidth variant="contained" color="secondary">Registration Policy</Button>*/}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <img src={events[currentTab].img2} alt="two" className={classes.sectionImg} />
                </Grid>
              </Grid>
            </div>
          </div>
          <FooterSpacer />
        </main>
        <Footer />
      </div>
    );
  }
}

DebbieRosasEventsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DebbieRosasEventsPage);
